import { useTranslation } from 'react-i18next'
import { Box, Button, Menu, MenuItem } from '@mui/material'
import LanguageIcon from '@mui/icons-material/Language'
import { useState } from 'react'
import { supportedLanguages, type AvailableLanguage } from '#app/i18n/translations'

// Lets the user override the detected language on the login/consent
// screens. The choice is persisted by the i18next detector into the
// parent-domain cookie, so it also carries back to the other Fixrate apps.
export default function LanguageSwitcher() {
    const { i18n } = useTranslation()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    // i18n.language may be a regional variant (e.g. "nb-NO"); normalise to
    // the base code we render in the menu.
    const current = (Object.keys(supportedLanguages) as AvailableLanguage[]).find((code) =>
        i18n.language?.startsWith(code)
    )

    const choose = (code: AvailableLanguage) => {
        void i18n.changeLanguage(code)
        setAnchorEl(null)
    }

    return (
        <Box>
            <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                startIcon={<LanguageIcon />}
                size="small"
                sx={{ color: 'rgba(255,255,255,0.85)', textTransform: 'none' }}
            >
                {current ? supportedLanguages[current] : supportedLanguages.nb}
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {(Object.keys(supportedLanguages) as AvailableLanguage[]).map((code) => (
                    <MenuItem key={code} selected={code === current} onClick={() => choose(code)}>
                        {supportedLanguages[code]}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    )
}
